import { POST } from "@/utils/axios";

export function apiGetPlatformVipList(){
    return POST('/pricePackage/list', {})
}
